import { createContext } from 'react';

import { ServiceContextTypes } from '@/modules/Services/Services.types';

export const ServiceContext = createContext({} as ServiceContextTypes);
